export const ASX = {
  id: 888,
  height: 5954754,
  data: {
    icon: "/imgs/icons/asset/asx.svg",
  },
};
